import { useMediaQuery } from 'react-responsive';
import styles from './healthcare-problem.module.css';
import Connect from '../../public/svg/connect.svg';
import ConnectMobile from '../../public/svg/connect-mobile.svg';
import HelpSwiper from '../../public/svg/help-swiper.svg';
import HealthcareSolutionList, { Solution } from './healthcare-solution-card';
import { Container } from '../../components';
import { useMounted } from '../../hooks';
import Description from './healthcare-description';

const solutions: Solution[] = [
  {
    src: 'healthcare/problem/apple.svg',
    alt: 'Icon apple',
    paperColor: '#EBFBF7',
    title: 'Healthy Food',
    text: 'What you eat is closely linked to your health. Nowadays, you can use a digital solution to get the nutrition plan that would be created according to your specific needs',
    btnLabel: 'Keto Kitchen',
    href: 'https://ketokitchenapp.com',
  },

  {
    src: 'healthcare/problem/pill.svg',
    alt: 'Icon pill',
    paperColor: '#F5F1FB',
    title: 'Medicine',
    text: 'In case of any disease, medical help is a must. The software developed for doctors and patients help to save time, avoid extra visits to the hospital, organise the prescribed meds.',
    btnLabel: 'Meds Planner',
    href: '#',
    disabledLink: true,
  },

  {
    src: 'healthcare/problem/time.svg',
    alt: 'Icon time',
    paperColor: '#FEF6EA',
    title: 'Regime',
    text: 'Tracking meals, taking meds and food supplements and sleep biorhythms becomes easier with the smart apps. Follow the regime with new technologies.',
    btnLabel: 'Keto Kitchen',
    href: 'https://ketokitchenapp.com',
  },
  {
    src: 'healthcare/problem/lifestyle.svg',
    alt: 'Icon lifestyle',
    paperColor: '#EAECFE',
    title: 'Active Lifestyle',
    text: 'Yoga, stretching, fitness, meditations, face gymnastics, physiotherapy - all these workout types are aimed at improving your health and all of them may fit in your pocket.',
    btnLabel: 'The Hera App',
    href: 'https://www.theheraapp.com',
  },
];

export default function HealthcareProblem() {
  const mounted = useMounted();
  const isMobile = useMediaQuery({ maxDeviceWidth: 767 });

  return (
    <section className={styles.problem}>
      <Container>
        <div className={styles.problem_inner}>
          <Description
            className={styles.problem_description}
            title="Problem"
            text="Our approach starts with identifying the problem that your future solution is supposed to solve. At the same time, we can highlight 4 main directions that help people to maintain their health."
          />

          {mounted && !isMobile ? (
            <Connect className={styles.problem_connect} />
          ) : (
            <ConnectMobile className={styles.problem_connectMobile} />
          )}

          <h5 className={styles.title}>Solutions and Relevant Projects</h5>

          {mounted && isMobile && (
            <HelpSwiper className={styles.problem_helpSwiper} />
          )}

          {mounted && isMobile && (
            <ConnectMobile className={styles.problem_connectMobile} />
          )}

          <img
            alt="multple-line"
            src="/svg/multple-line.svg"
            className={styles.multpleLine}
          />
        </div>
        <HealthcareSolutionList solutions={solutions} />
      </Container>
    </section>
  );
}
